import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  HOSTING_DC_ADDRESS,
  HOSTING_NAME,
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_PHONE,
  OPERATOR_REGION,
  POLICY_DATE,
  PROCESSING_START_DATE,
  SITES_LABEL,
} from '../legal/operator';

export default function ConsentPage() {
  return (
    <LegalDoc title="Согласие на обработку персональных данных">
      <p>
        Настоящее согласие — отдельный документ. Оно не является частью{' '}
        <Link to={OFERTA_PATH}>договора-оферты</Link>
        . Текст политики:{' '}
        <Link to="/privacy">Политика обработки персональных данных</Link>.
      </p>
      <p>
        Редакция: {POLICY_DATE}. Обработка с согласия начинается не ранее{' '}
        {PROCESSING_START_DATE}.
      </p>

      <h2>1. Кто даёт согласие</h2>
      <p>
        Субъект персональных данных — тот, кто ставит отметку в форме регистрации
        на Сайте ({SITES_LABEL}) и передаёт свои данные: ученик с 14 лет либо
        родитель (законный представитель). Субъект идентифицируется по сведениям
        формы (имя, логин, email).
      </p>
      <p>
        Ученик, которому уже есть 14 лет, даёт это согласие сам. Согласие родителя
        на обработку персональных данных такого ученика не требуется.
      </p>
      <p>
        Если ученику нет 14 лет, он на Сайте не регистрируется. Согласие на его
        данные даёт родитель.
      </p>
      <p>
        Договор на обучение — отдельный документ, не этот текст. Его заключает
        родитель: регистрируется по ссылке-приглашению и принимает{' '}
        <Link to={OFERTA_PATH}>договор-оферту</Link>. Отметка ученика в форме
        регистрации договор не заключает.
      </p>

      <h2 id="child">Согласие родителя на данные ребёнка</h2>
      <p>
        Родитель с аккаунтом на Сайте может отдельно согласиться на обработку
        персональных данных ребёнка и передать ему ссылку на регистрацию. Согласие
        даётся до создания учётной записи ребёнка и относится к имени, логину,
        адресу электронной почты и учебным сведениям, которые ребёнок укажет по
        этой ссылке и дальше на Сайте.
      </p>
      <p>
        Так регистрируется в том числе ребёнок младше 14 лет: сам он согласие дать
        не может, его даёт родитель. Ребёнок с 14 лет по-прежнему может
        зарегистрироваться сам и дать согласие лично; ссылка родителя этот путь
        не отменяет.
      </p>

      <h2>2. Оператор</h2>
      <ul>
        <li>{OPERATOR_NAME}</li>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>ОГРНИП: {OPERATOR_OGRNIP}</li>
        <li>Регион регистрации: {OPERATOR_REGION}</li>
        <li>
          Email:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>Телефон: {OPERATOR_PHONE}</li>
      </ul>

      <h2>3. Цели</h2>
      <p>
        Подготовка, заключение и исполнение гражданско-правового договора на
        оказание образовательных услуг через Сайт, а именно:
      </p>
      <ol>
        <li>Создание и ведение учётной записи, вход на Сайт.</li>
        <li>
          Оказание образовательных услуг: занятия (в том числе через Яндекс&nbsp;Телемост
          или «Макс»), задания, проверка решений, журнал, переписка на Сайте,
          отображение прогресса преподавателю и родителю (если связь настроена).
        </li>
        <li>
          Анкета ученика (цели подготовки, опыт, нагрузка, финансовые возможности) — чтобы
          согласовать формат занятий.
        </li>
        <li>Приём оплаты и направление чека.</li>
        <li>Связь по выбранному каналу (email, «Макс», телефон) и уведомления (если включены).</li>
        <li>Безопасность и работоспособность Сайта.</li>
      </ol>
      <p>
        Согласие на Яндекс.Метрику и Вебвизор оформляется отдельно через баннер
        cookie на Сайте и не является частью настоящего документа.
      </p>

      <h2>4. Перечень данных</h2>
      <p>
        В том числе фамилия, имя, отчество и адрес электронной почты. Также
        обрабатываются: логин, хеш пароля, канал связи, сведения профиля (телефон,
        город, школа, класс, роль, аватар), ответы анкеты, код и
        результаты решений, данные о присутствии на занятии, журнал занятий,
        сообщения в ленте на Сайте, сведения об оплате, технические данные
        (cookie сессии, IP в журналах сервера). Cookie Яндекс.Метрики и Вебвизор —
        только после отдельного согласия в баннере cookie.
      </p>

      <h2>5. Действия и способы</h2>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, передача (предоставление) указанным в
        Политике получателям, блокирование, обезличивание, удаление, уничтожение.
        Обезличивание: при отзыве согласия или запросе об удалении из учётной записи
        убираются сведения, позволяющие определить субъекта; запись и обезличенная
        учебная статистика могут сохраняться (подробнее — в Политике).
        Обработка — автоматизированная, с передачей по сети
        Интернет, с использованием Сайта и базы данных на территории РФ (
        {HOSTING_NAME}, {HOSTING_DC_ADDRESS}).
      </p>
      <p>
        Получатели в объёме, нужном для цели: хостинг {HOSTING_NAME}, Озон Пай,
        почтовый сервис, Яндекс.Метрика — после согласия в баннере,
        Яндекс&nbsp;Телемост — при онлайн-занятии через этот сервис,
        «Макс» или ВКонтакте — если вы указали этот канал или согласились на
        уведомления через бота.
      </p>

      <h2>6. Срок и отзыв</h2>
      <p>
        Согласие действует с момента отметки в форме до отзыва либо до достижения
        целей обработки (в том числе обезличивания учётной записи), если закон не
        требует хранить данные дольше (расчёты).
      </p>
      <p>
        Отозвать согласие и потребовать удаление можно письмом на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        . Запрос обрабатывается в срок не позднее 10 рабочих дней.
        Отзыв не затрагивает обработку, которая уже выполнена, и обработку,
        необходимую для исполнения договора и закона.
        Согласие на Метрику и Вебвизор отзывается через «Настройки cookie» в подвале.
      </p>

      <h2>7. Добровольность</h2>
      <p>
        Согласие даётся свободно, своей волей и в своём интересе. Без согласия
        регистрация на Сайте недоступна: услуги оказываются через личный кабинет.
      </p>
    </LegalDoc>
  );
}
